var _a;
import { isArray } from 'lodash';
const defaultBackgroundConfig = {
    type: 'none',
};
const assetPath = (_a = window.STATIC_ASSETS_PATH) !== null && _a !== void 0 ? _a : './assets';
let backgroundImageUrls = [
    'kenny-eliason-Wp7t4cWN-68-unsplash',
    'jonny-caspari-KuudDjBHIlA-unsplash',
    'roman-bozhko-PypjzKTUqLo-unsplash',
    'vinicius-amnx-amano-17NCG_wOkMY-unsplash',
    'dmytro-tolokonov-Jq3WI9IQgEs-unsplash',
    'andrew-ridley-jR4Zf-riEjI-unsplash',
    'annie-spratt-OWq8w3BYMFY-unsplash',
    'evelyn-bertrand-GrIf347OtnY-unsplash',
    'steve-richey-6xqAK6oAeHA-unsplash',
    'erol-ahmed-IHL-Jbawvvo-unsplash',
].map((imageName) => `${assetPath}/backgrounds/${imageName}.jpg`);
if (typeof window.PNM_VIRTUAL_BG_IMGS !== 'undefined' &&
    isArray(window.PNM_VIRTUAL_BG_IMGS) &&
    window.PNM_VIRTUAL_BG_IMGS.length > 0) {
    const bgImgUrls = window.PNM_VIRTUAL_BG_IMGS;
    const imgUrls = [];
    (async () => {
        for (let i = 0; i < bgImgUrls.length; i++) {
            const url = bgImgUrls[i];
            try {
                const req = await fetch(url, { method: 'HEAD' });
                if (req.ok) {
                    imgUrls.push(url);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        if (imgUrls.length) {
            backgroundImageUrls = imgUrls;
        }
    })();
}
export { backgroundImageUrls, defaultBackgroundConfig };
